/**
 * What the friction feed put on the friction and rubber boards, for the shell.
 *
 * Imports nothing, for the reason `report.ts` gives: the shell reads it on
 * every screen, and the merge behind it pulls in the demo's tables.
 */

export interface FrictionReport {
  /** set once the platform's record has been put into the boards */
  live: boolean;
  surveys: number;
  tests: number;
  removals: number;
  returns: number;
  /** what could not be read, and why — the board then shows only this browser's own entries */
  refused: string[];
}

const empty = (): FrictionReport => ({ live: false, surveys: 0, tests: 0, removals: 0, returns: 0, refused: [] });

let report = empty();
const listeners = new Set<() => void>();

export const frictionReport = (): FrictionReport => report;

export function setFrictionReport(patch: Partial<FrictionReport> & { refusedKey?: string; refusedWhy?: string }): void {
  const { refusedKey, refusedWhy, ...rest } = patch;
  let refused = report.refused.filter((r) => !refusedKey || !r.startsWith(`${refusedKey}:`));
  if (refusedKey && refusedWhy) refused = [...refused, `${refusedKey}: ${refusedWhy}`];
  report = { ...report, ...rest, refused, live: true };
  for (const fn of listeners) fn();
}

export function clearFrictionReport(): void {
  report = empty();
  for (const fn of listeners) fn();
}

export function subscribeFrictionReport(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
